__turbopack_context__.v({
  "MonthlyMovies": "MVkNOa_MonthlyMovies",
});
